import { useNavigation } from "@react-navigation/native";
import React from "react";
import {
  FlatList,
  StatusBar,
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
} from "react-native";
import AllIdentity from "../components/AllIdentity";
import { useDispatch, useSelector } from "react-redux";
import { selectIdentityList, deleteIdentity } from "../store/identitySlice";
import { deleteAllMedical } from "../store/medicalSlice";

const IdentityScreen = () => {
  const navigation = useNavigation();
  const dispatch = useDispatch()

  const back = () => {
    console.log("back");
    navigation.navigate("Home");
  };

  const logOut = () => {
    console.log("logout");
    dispatch(deleteIdentity())
    dispatch(deleteAllMedical())
    navigation.navigate("Login");
  };

  const identityList = useSelector(selectIdentityList);

  return (
    <View style={styles.allIdentity}>
      <FlatList
        data={identityList}
        renderItem={({ item }) => <AllIdentity item={item} />}
        showsVerticalScrollIndicator={false}
        style={{ marginBottom: 75 }}
      />
      <TouchableOpacity onPress={back}>
        <View style={styles.identityButton}>
          <Text style={styles.identityButtonText}>Kembali</Text>
        </View>
      </TouchableOpacity>
      <TouchableOpacity onPress={logOut}>
        <View style={styles.identityButtonLogout}>
          <Text style={styles.identityButtonText}>Log Out</Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default IdentityScreen;

const styles = StyleSheet.create({
  allIdentity: {
    flex: 1,
    backgroundColor: "#F8F8F8",
    paddingTop: StatusBar.currentHeight,
    paddingHorizontal: "15%",
  },
  identityButton: {
    backgroundColor: "#FF2828",
    paddingVertical: 10,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 5,
    position: "absolute",
    bottom: 100,
    width: "100%",
  },
  identityButtonText: {
    color: "#F8F8F8",
    fontWeight: "500",
    fontSize: 16,
  },
  identityButtonLogout: {
    backgroundColor: "#FF2828",
    paddingVertical: 10,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 5,
    position: "absolute",
    bottom: 20,
    width: "100%",
  },
});
